export default {
  pageTitle: 'Layanan Welding Overlay',
  metaDescription: 'TEF menyediakan layanan welding overlay untuk memperbaiki dan melindungi permukaan peralatan, memperpanjang umur pakai vessel, nozzle, dan peralatan proses.',
  sidebar: {
    title: 'Daftar Maintenance dan Rekondisi',
    weldingOverlay: 'Welding Overlay',
    patching: 'Patching',
    piping: 'Piping',
    reShell: 'Re-Shell',
    reTubing: 'Re-Tubing',
  },
  productName: 'Welding Overlay',
  subheading: 'Layanan Pengelasan Overlay dan Finishing di Lokasi (On-Site)',
  paragraph1: 'Kami menyediakan layanan pengelasan overlay (deposit overlay) dan finishing khusus, menggunakan mesin portabel yang menghadirkan presisi dan efisiensi langsung ke lokasi Anda. Proses kami meningkatkan daya tahan dan performa komponen Anda dengan menerapkan material overlay berkualitas tinggi yang disesuaikan dengan kebutuhan spesifik Anda.',
  paragraph2: 'Teknisi kami yang berpengalaman memastikan pelaksanaan pekerjaan berjalan lancar, baik untuk perbaikan, peningkatan permukaan, maupun ketahanan terhadap korosi. Dengan mengerjakan langsung di lokasi, kami meminimalkan downtime dan menghilangkan kebutuhan untuk mengangkut peralatan berat atau kompleks.',
  paragraph3: 'Rasakan kemudahan solusi pengelasan dan finishing tingkat lanjut yang dihadirkan langsung ke tempat Anda membutuhkannya.',
  gallery: {
    overlayNozzle: 'Overlay Nozzle',
    machiningSurface: 'Machining Permukaan',
    overlayChannel: 'Overlay Channel',
    finishingSurface: 'Finishing Permukaan',
    finishMachiningSurface: 'Machining Akhir Permukaan',
  },
};
